import React, { ReactElement, useMemo } from "react";
import { fundKRFeeState, selectedRowState } from "@states/fundKr";
import { useRecoilValue, useRecoilValueLoadable } from "recoil";
import UndlPanel from "./Panel/UndlPanel";
import AnalysisPanel from "./Panel/AnalysisPanel";
import { TabContents } from "@components/tab/TabPanel";
import FeePanel from "./Panel/FeePanel"

function AssetViewerTabs(): ReactElement {
  const selectedRow = useRecoilValue(selectedRowState);

  // 운영중인 펀드 29,171개 중 5,208개(17.9%)는 보수 이력이 아예 없다. 사모펀드는
  // 공시 대상이 아니라 구조적으로 없고(1,610개), 신설 펀드는 첫 월말 집계 전이다.
  // 들어가 봐야 빈 표만 보이므로 탭을 아예 막고 이유를 이름에 적는다.
  //
  // useRecoilValue 가 아니라 Loadable 인 이유: 이 컴포넌트는 Suspense 안에 있어서
  // (fund/index.tsx:34) selector 를 그냥 읽으면 보수 조회가 끝날 때까지 헤더와 탭
  // 전체가 로딩 화면으로 바뀐다. Loadable 은 대기 상태를 값으로 받아 그냥 그린다.
  //
  // 목록 행에도 `총보수(A)` 같은 필드가 있어서 그걸로 대신할 수 있을까 싶었는데,
  // 표본 200개로 재보니 목록 필드는 **항상 채워져 있었다**(공백 0건). 그중 55개가
  // 이력 0행이라 예측이 안 된다. `공모/사모구분` 도 마찬가지로 절반만 맞는다.
  // 결국 이력을 직접 봐야 한다.
  const feeLoadable = useRecoilValueLoadable(fundKRFeeState);

  // 서버가 "0행" 이라고 분명히 답한 경우에만 막는다. selector 가 조회 실패를
  // catch 해서 undefined 로 돌려주기 때문에(states/fundKr.ts:144) undefined 를
  // '없음' 으로 치면 일시적인 오류까지 '데이터없음' 으로 낙인찍게 된다.
  // 그 경우는 탭을 열어두고 패널이 기존대로 안내한다.
  const feeEmpty =
    feeLoadable.state === "hasValue" &&
    Array.isArray(feeLoadable.contents?.rows) &&
    feeLoadable.contents.rows.length === 0;

  const contents = useMemo(
    () => [
      {
        label: "가상 지수",
        component: <UndlPanel />,
      },
      {
        label: "분석",
        component: <AnalysisPanel />,
      },
      {
        label: feeEmpty ? "수수료 (데이터없음)" : "수수료",
        component: <FeePanel />,
        disabled: feeEmpty,
      },
    ],
    [feeEmpty]
  );

  if (!selectedRow) {
    return <></>;
  }

  return (
    <TabContents tabs={contents} />
  );
}

export default AssetViewerTabs;
